/**
 * frontend/src/lib/nominationsStore.js — the signed-in player's nominations, shared by every
 * Nominate button (one fetch per session, updated in place after each nomination).
 */

import { useEffect, useSyncExternalStore } from 'react';
import { myNominations, nominateArtist } from './archiveApi';

let state = { loaded: false, artistIds: new Set(), usedThisWeek: 0, limit: 5, nextSlotAt: null };
let loading = null;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());
const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };
const snapshot = () => state;

export function loadNominations(force = false) {
  if (loading && !force) return loading;
  loading = myNominations()
    .then((d) => {
      state = { loaded: true, artistIds: new Set(d.artistIds || []), usedThisWeek: d.usedThisWeek || 0, limit: d.limit || 5, nextSlotAt: d.nextSlotAt || null };
      emit();
    })
    .catch(() => { state = { ...state, loaded: true }; emit(); });
  return loading;
}

export async function nominate(artistId) {
  const r = await nominateArtist(artistId);   // throws ApiError (NOMINATION_LIMIT, NOT_ACTIVE, …)
  const ids = new Set(state.artistIds);
  ids.add(artistId);
  state = { ...state, artistIds: ids, usedThisWeek: r.status === 'nominated' ? (r.used ?? state.usedThisWeek + 1) : state.usedThisWeek };
  emit();
  return r;
}

export function useNominations() {
  const s = useSyncExternalStore(subscribe, snapshot);
  useEffect(() => { if (!s.loaded) loadNominations(); }, [s.loaded]);
  return s;
}
